import { render, staticRenderFns } from "./DSFileUpload.vue?vue&type=template&id=9a4cfeb8&scoped=true&"
import script from "./DSFileUpload.vue?vue&type=script&lang=js&"
export * from "./DSFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./DSFileUpload.vue?vue&type=style&index=0&id=9a4cfeb8&prod&lang=css&scoped=true&"
import style1 from "./DSFileUpload.vue?vue&type=style&index=1&id=9a4cfeb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4cfeb8",
  null
  
)

export default component.exports